import type { SyntheticEvent } from 'react'

import Spinner from '@jotta/ui/Spinner'
import SvgCircle from '@jotta/ui/SvgCircle'
import SvgMultiSelectColored from '@jotta/ui/SvgMultiSelectColored'
import { cn } from '@jotta/utils/css'

export function PhotoCheckbox({
  className,
  isSelected,
  onToggleSelect,
  loading,
}: {
  className?: string
  isSelected: boolean
  onToggleSelect: (selected: boolean, e: SyntheticEvent) => void
  loading?: boolean
}) {
  return (
    <button
      type="button"
      aria-checked={isSelected}
      role="checkbox"
      data-skip-click
      onClick={e => onToggleSelect(!isSelected, e)}
      className={cn(
        'h-6 rounded-full focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-m3-primary',
        className,
      )}
    >
      {loading ? (
        <Spinner size="small" />
      ) : isSelected ? (
        <SvgMultiSelectColored
          className={cn('h-full text-on-primary-container')}
        />
      ) : (
        <SvgCircle className="h-full text-border-light" />
      )}
    </button>
  )
}
